"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("../Text"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Image = _interopRequireDefault(require("../Image"));

var _react = _interopRequireDefault(require("react"));

var _constant = require("./constant");

var _SelectionUnavailable = _interopRequireDefault(require("./SelectionUnavailable.proptypes"));

var MealWrapper = _styledComponents.default.div.withConfig({
  displayName: "SelectionUnavailable__MealWrapper",
  componentId: "sc-10r9tc0-0"
})(["display:flex;flex-direction:column;align-items:center;width:", ";margin:auto;padding:", ";"], function (_ref) {
  var theme = _ref.theme,
      width = _ref.width;
  return width || theme.space.XXXXLarge;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.standard;
});

var TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "SelectionUnavailable__TextWrapper",
  componentId: "sc-10r9tc0-1"
})(["display:flex;flex-direction:column;align-items:center;"]);

var ImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "SelectionUnavailable__ImageWrapper",
  componentId: "sc-10r9tc0-2"
})(["margin-bottom:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.small;
});

var SelectionUnavailable = function SelectionUnavailable(_ref4) {
  var title = _ref4.title,
      message = _ref4.message,
      theme = _ref4.theme,
      url = _ref4.url,
      width = _ref4.width,
      placeHolderBackground = _ref4.placeHolderBackground;
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(MealWrapper, {
    width: width
  }, /*#__PURE__*/_react.default.createElement(ImageWrapper, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: url,
    alt: _constant.IMAGE_NOT_FOUND,
    width: _constant.IMAGE.width,
    height: _constant.IMAGE.height,
    placeHolderBackground: placeHolderBackground
  })), /*#__PURE__*/_react.default.createElement(TextWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: _constant.SIZE.medium,
    bold: true,
    textAlign: _constant.ALIGN.center,
    marginBottom: "tiny"
  }, title), /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: _constant.SIZE.textSmall,
    color: _constant.COLOR.greyDark,
    textAlign: _constant.ALIGN.center
  }, message))));
};

SelectionUnavailable.propTypes = _SelectionUnavailable.default.PropTypes;
SelectionUnavailable.defaultProps = _SelectionUnavailable.default.defaultProps;
var _default = SelectionUnavailable;
exports.default = _default;